export default __webpack_public_path__ + "static/media/close-red.aa2e42e0.svg";